import { createContext } from "react";

export const LocationSelectorContext = createContext();
